import { CachedSignedImageWithShimmer } from "./CachedSignedImage";
import ImageModal from "./ImageModal";

const CachedSignedImageModal = (props: { src: string; width: number; height: number }) => {
  return <ImageModal {...props} element={CachedSignedImageWithShimmer} />;
};

export default CachedSignedImageModal;
